import {SoundPlayable} from '../../../vendor/react-native-tapnovel-viewer';

export default SoundPlayable;
